import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'addressSplit'
})
export class AddressSplitPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if (value) {
      const address = value.lastIndexOf(',') !== -1 ? value.slice(0, value.lastIndexOf(',')) : value;
      return address;
    }
  }

}
